import React from 'react';
import { Link } from 'react-router-dom';

import '../../Assets/Layout/Sidebar.css';

const MENUS = [
    {
        type: 'title',
        text: 'Accueil'
    },
    {
        type: 'link',
        href: '/',
        name: 'Accueil',
        icon: 'zmdi zmdi-home'
    },
    {
        type: 'group',
        name: 'Docteurs',
        href: '/doctors', // Base path
        icon: 'zmdi zmdi-hospital',
        elements: [
            {
                name: 'Tous',
                href: '/doctors'
            },
            {
                name: 'En attente',
                href: '/doctors/waiting'
            },
            {
                name: 'Disponible',
                href: '/doctors/active'
            },
            {
                name: 'Avis',
                href: '/feedback'
            },
            {
                name: 'Récurrence médecins',
                href: '/analytics/recurrence-medecins'
            },
            {
                name: 'Abandons docteur',
                href: '/analytics/doctor-cancellations'
            },
            {
                name: 'Comportement docteur',
                href: '/analytics/doctor-behavior'
            },
            {
                name: 'Refus quotidiens',
                href: '/analytics/doctor-refusals-daily'
            }
        ]
    },
    {
        type: 'group',
        href: '/pharmacy',
        name: 'Pharmacies',
        icon: 'zmdi zmdi-hospital',
        elements: [
            {
                name: 'Tous',
                href: '/pharmacy'
            },
            {
                name: 'Pré-inscription',
                href: '/pharmacy/pre-inscri'
            },
            {
                name: 'Pharmaciens',
                href: '/pharmacist'
            }
        ]
    },
    {
        type: 'link',
        href: '/users',
        name: 'Utilisateurs',
        icon: 'zmdi zmdi-accounts-alt'
    },
    {
        type: 'link',
        href: '/subscriptions',
        name: 'Abonnements',
        icon: 'zmdi zmdi-card-membership'
    },
    {
        type: 'group',
        href: '/requests',
        name: 'Requêtes',
        icon: 'zmdi zmdi-file',
        elements: [
            {
                name: 'Toutes',
                href: '/requests'
            },
            {
                name: 'Capture en attente',
                href: '/requests-pending-capture'
            },
            {
                name: 'Emails de relance',
                href: '/analytics/followup-emails'
            },
            {
                name: 'Annuler "en attente" anciennes',
                href: '/requests/cancel-stale-waiting'
            }
        ]
    },
    {
        type: 'link',
        href: '/signalements',
        name: 'Signalements',
        icon: 'zmdi zmdi-flag'
    },
    {
        type: 'group',
        href: '/communication',
        name: 'Communication',
        icon: 'zmdi zmdi-notifications',
        elements: [
            {
                name: 'Notification',
                href: '/notification'
            },
            {
                name: 'Newsletters',
                href: '/newsletters'
            },
            {
                name: 'Avis du site (Trustpilot)',
                href: '/site/avis'
            }
        ]
    },
    {
        type: 'group',
        href: '/analytics',
        name: 'Analytique',
        icon: 'zmdi zmdi-chart',
        elements: [
            {
                name: 'Tunnel de conversion',
                href: '/conversion-tunnel',
                icon: 'zmdi zmdi-chart'
            },
            {
                name: 'Performance Google Ads',
                href: '/analytics/google-ads',
                icon: 'zmdi zmdi-trending-up'
            },
            {
                name: 'Analyse des requetes',
                href: '/analytics/request',
                icon: 'zmdi zmdi-file-text'
            },
            {
                name: 'Analyse des utilisateurs',
                href: '/analytics/user',
                icon: 'zmdi zmdi-accounts'
            },
            {
                name: 'Analyse des médecins',
                href: '/analytics/doctor',
                icon: 'zmdi zmdi-face'
            },
            {
                name: 'Recherche symptômes',
                href: '/analytics/recherche-symptomes',
                icon: 'zmdi zmdi-search'
            },
            {
                name: 'Analyse récurrence client',
                href: '/analytics/customer-value',
                icon: 'zmdi zmdi-refresh-sync'
            },
            {
                name: 'Liste récurrence client',
                href: '/analytics/recurrence-list',
                icon: 'zmdi zmdi-format-list-bulleted'
            },
            {
                name: 'Cohorte clients',
                href: '/analytics/cohorte-clients',
                icon: 'zmdi zmdi-accounts-list'
            },
            {
                name: 'International',
                href: '/analytics/international',
                icon: 'zmdi zmdi-globe'
            },
            {
                name: 'LTV',
                href: '/analytics/ltv',
                icon: 'zmdi zmdi-trending-up'
            },
            {
                name: 'LTV par client',
                href: '/analytics/ltv-customer',
                icon: 'zmdi zmdi-account-circle'
            },
            {
                name: 'Suivi annulé',
                href: '/analytics/tracking-cancel',
                icon: 'zmdi zmdi-close-circle'
            },
            {
                name: 'Suivi incomplet',
                href: '/analytics/tracking-incomplete',
                icon: 'zmdi zmdi-alert-triangle'
            },
            {
                name: 'Suivi en attente',
                href: '/analytics/tracking-waiting',
                icon: 'zmdi zmdi-time'
            },
            {
                name: 'A/B Tests',
                href: '/analytics/ab-tests',
                icon: 'zmdi zmdi-chart-donut'
            },
            {
                name: 'Moyens de paiement',
                href: '/analytics/payment-methods',
                icon: 'zmdi zmdi-card'
            },
        ]
    },
    {
        type: 'group',
        href: '/campagne-sdr',
        name: 'Campagnes',
        icon: 'zmdi zmdi-email',
        elements: [
            {
                name: 'Campagne SDR',
                href: '/campagne-sdr'
            },
            {
                name: 'Historique des relances',
                href: '/relance-history'
            },
            {
                name: 'Suivi des relances',
                href: '/relance-suivi'
            },
            {
                name: 'Gestion file d\'attente',
                href: '/lead-capital'
            },
            {
                name: 'Dermato sdr',
                href: '/dermato-sdr'
            },
            {
                name: 'Dermato complétions',
                href: '/dermato-sdr/completions'
            },
            {
                name: 'RGPD comptes inactifs',
                href: '/gdpr-warning'
            },
            {
                name: 'Opt-in WhatsApp (email)',
                href: '/whatsapp-optin'
            },
            {
                name: 'Campagne parrainage',
                href: '/campagne-parrainage'
            }
        ]
    },
    {
        type: 'group',
        href: '/marketing',
        name: 'Marketing',
        icon: 'zmdi zmdi-trending-up',
        elements: [
            {
                name: 'Parrainage',
                href: '/referral-stats'
            },
            {
                name: 'Acquisition',
                href: '/acquisition'
            }
        ]
    },
    {
        type: 'group',
        href: '/suivis',
        name: 'Nouveau suivis',
        icon: 'zmdi zmdi-assignment-check',
        elements: [
            {
                name: 'Suivis dermatologie',
                href: '/suivis/dermato'
            },
            {
                name: 'Suivis pathologie',
                href: '/suivis/pathologie'
            },
            {
                name: 'Suivis → reconsultation',
                href: '/suivis/reconsultation'
            },
            {
                name: 'Lien suivi WhatsApp',
                href: '/suivis/lien-whatsapp'
            }
        ]
    },
    {
        type: 'link',
        href: '/suivi',
        name: 'Les suivis',
        icon: 'zmdi zmdi-assignment'
    },
    {
        type: 'link',
        href: '/pricing-config',
        name: 'Tarifs',
        icon: 'zmdi zmdi-money'
    },
];

const MENUS_PARTNER = [
    {
        type: 'title',
        text: 'Accueil'
    },
    {
        type: 'link',
        href: '/',
        name: 'Accueil',
        icon: 'zmdi zmdi-home'
    },
    {
        type: 'link',
        href: '/requests',
        name: 'Requêtes',
        icon: 'zmdi zmdi-file'
    }
];

const MENUS_VISITOR = [
    {
        type: 'title',
        text: 'Accueil'
    },
    {
        type: 'group',
        href: '/tester',
        name: 'Testeurs',
        icon: 'zmdi zmdi-truck',
        elements: [
            {
                name: 'Tous',
                href: '/testers'
            },
            {
                name: 'En attente',
                href: '/testers/waiting'
            }
        ]
    },
    {
        type: 'group',
        href: '/tests',
        name: 'Tests',
        icon: 'zmdi zmdi-pin',
        elements: [
            {
                name: 'Tous',
                href: '/tests'
            },
            {
                name: 'En attente',
                href: '/tests/waiting'
            },
            {
                name: 'À approuver',
                href: '/tests/toapproved'
            }
        ]
    }
];

const MENUS_ADMIN_FISCALE = [
    {
        type: 'title',
        text: 'Accueil'
    },
    {
        type: 'link',
        href: '/',
        name: 'Accueil',
        icon: 'zmdi zmdi-home'
    },
    {
        type: 'link',
        href: '/requests',
        name: 'Requêtes',
        icon: 'zmdi zmdi-file'
    }
];

class MenuGroup extends React.Component {
    constructor() {
        super();

        this.state = {
            activeMenu: null,
            menuVisible: false
        };
    }

    componentDidMount() {
        const pathName = window.location.pathname;

        let i;
        for (
            i = 0;
            i < this.props.elements.length &&
            this.props.elements[i].href !== pathName;
            i++
        );

        this.setState({ activePage: i });
    }

    render() {
        return (
            <div
                className="link"
                onClick={() =>
                    this.setState({ menuVisible: !this.state.menuVisible })
                }
            >
                <i className={this.props.icon} />
                <span>{this.props.name}</span>
                <ul
                    style={{
                        display: this.state.menuVisible ? 'initial' : 'none'
                    }}
                >
                    {this.props.elements.map((e, i) => {
                        return (
                            <li key={i}>
                                <Link
                                    to={e.href}
                                    onClick={() => {
                                        this.setState({ activePage: i });
                                        this.props.onClick(this.props.i);
                                    }}
                                >
                                    {e.icon && <i className={e.icon} />}
                                    <span>{e.name}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default class Sidebar extends React.Component {
    constructor() {
        super();

        this.state = {
            activePage: null
        };
    }

    componentDidMount() {
        const pathName = window.location.pathname.match(/\/[^/]*/g)[0];

        let i;
        for (i = 0; i < MENUS.length && MENUS[i].href !== pathName; i++);

        this.setState({ activePage: i });
    }

    renderMenu() {
        if (this.props.role === 4) {
            return MENUS_PARTNER;
        }
        if (this.props.role === 5) {
            return MENUS_ADMIN_FISCALE
        }

        return this.props.role >= 2 ? MENUS : MENUS_VISITOR;
    }

    handleLinkClick = () => {
        // Close menu on mobile when a link is clicked
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        const { isOpen } = this.props;
        return (
            <>
                {isOpen && <div className="Sidebar-overlay" onClick={this.props.onClose} />}
                <div className={`Sidebar ${isOpen ? 'open' : ''}`}>
                    <ul>
                        {this.renderMenu().map((e, i) => {
                        if (e.type === 'title') {
                            return (
                                <li key={i} className="title">
                                    <span>{e.text}</span>
                                </li>
                            );
                        } else if (e.type === 'link') {
                            return (
                                <li
                                    key={i}
                                    className={
                                        this.state.activePage === i
                                            ? 'active'
                                            : ''
                                    }
                                >
                                    <Link
                                        to={e.href}
                                        onClick={() => {
                                            this.setState({ activePage: i });
                                            this.handleLinkClick();
                                        }}
                                    >
                                        <i className={e.icon} />
                                        <span>{e.name}</span>
                                    </Link>
                                </li>
                            );
                        } else if (e.type === 'group') {
                            return (
                                <li
                                    key={i}
                                    className={
                                        this.state.activePage === i
                                            ? 'active'
                                            : ''
                                    }
                                >
                                    <MenuGroup
                                        {...e}
                                        onClick={() =>
                                            this.setState({ activePage: i })
                                        }
                                    />
                                </li>
                            );
                        }

                        return null;
                    })}
                </ul>
            </div>
            </>
        );
    }
}
